import React, {FC, useEffect, useState} from "react";
import JoinIcon from "../assets/images/icon_join.svg";
import {Link} from "react-router-dom";

type JoinCompleteProps = {
    usrNm: string;
    secondStepVisibleYn: string;
}

const JoinComplete: FC<JoinCompleteProps> = ({ usrNm , secondStepVisibleYn}) => {
    const [visibleStyle, setVisibleStyle] = useState('false')

    useEffect(() => {
         if(secondStepVisibleYn === 'false') setVisibleStyle('true')
    }, [visibleStyle, secondStepVisibleYn]);

        return (
        <div className={`join-complete-wrapper ${visibleStyle==='true' ? 'show' : 'no-show'}`}>
            <div className={'join-complete-content'}>
                <div className={'join-complete-logo-wrapper text-center'}>
                    <img src={JoinIcon} alt={'회원가입 완료 아이콘'} />
                </div>
                <div className={'join-complete-text-wrapper'}>
                    <div className={'join-complete-text-header text-center'}>
                        <span>회원가입 완료!</span>
                    </div>
                    <div className={'join-complete-text-desc text-center'}>
                        <span>{usrNm}님의 회원가입을 환영합니다.</span>
                    </div>
                </div>
                <div className={'join-complete-button-wrapper text-center'}>
                    <Link to={'/login'}>
                        <button>로그인페이지로 이동</button>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default JoinComplete;
